import { CountUp } from 'countup.js';
import './front-statistic-box.scss';

const { _x } = window.wp.i18n;

document.addEventListener( 'DOMContentLoaded', function () {
	const counters = document.querySelectorAll(
		'.statistics-block[data-animated="true"] .countUp'
	);

	if ( 0 < counters.length ) {
		counters.forEach( function ( counter ) {
			const isFrench = document.documentElement.lang
				.toLowerCase()
				.startsWith( 'fr' );
			const number = parseFloat( counter.getAttribute( 'data-number' ) );
			const animation = new CountUp( counter, number, {
				duration: 2,
				// Hotfix while figuring out why WPML is not findting translations in JS files
				separator: isFrench ? ' ' : ',', //_x( ',', 'number thousand separator', 'vtx' ),
				decimal: isFrench ? ',' : '.', //_x( '.', 'decimal separator', 'vtx' ),
				decimalPlaces: parseInt(
					counter.getAttribute( 'data-decimal-place' )
				),
				enableScrollSpy: true,
				scrollSpyDelay: 300,
			} );

			animation.handleScroll();
		} );
	}
} );
